// @flow

import pdbComparison from './reducer';
import type { State, PdbPrices } from './types';
import {
  hydrateComparison,
  setPdbId,
  toggleActivePdbId,
  unsetAllPdbIdsSetCompareClose,
  unsetPdbId,
  fetchPdbItems,
  receivePdbIds,
  getIsCompareOpen,
  toggleCompareOpen,
  unsetAllPdbIds,
} from './actions';
import {
  getBasePricesForPdbIds,
  getPricesForPdbIds,
  getPdbIds,
  isPdbIdInComparison,
  numPdbsInComparison,
  getTechSpecsForPdbIds,
  getComparedPricesForPdbIds,
  shouldShowPopup,
  isPdbComparisonFull,
  getComparisonText,
} from './selectors';

export type { State, PdbPrices };

export {
  receivePdbIds,
  fetchPdbItems,
  getPdbIds,
  hydrateComparison,
  isPdbIdInComparison,
  numPdbsInComparison,
  setPdbId,
  toggleActivePdbId,
  unsetAllPdbIdsSetCompareClose,
  unsetAllPdbIds,
  unsetPdbId,
  getTechSpecsForPdbIds,
  getBasePricesForPdbIds,
  getPricesForPdbIds,
  getComparedPricesForPdbIds,
  shouldShowPopup,
  isPdbComparisonFull,
  getComparisonText,
  getIsCompareOpen,
  toggleCompareOpen,
};

export default pdbComparison;
